module.exports = __webpack_public_path__ + "static/media/Sanchit_Rajmane.6ac3758d.jpg";